//GLOBAL - components from npm
import React, { useRef, useState } from "react";
import AudioPlayer, { RHAP_UI } from "react-h5-audio-player";

//STYLES
import "./audio.css";

//COMPONENTS
import Typography from "../../components/Typography";
import UserPhoto from "../UserPhoto/userphoto";

//SERVICES - api, conectors...
import urlIngWeb from "../../actions/urlIngWeb";

//GLOBAL STATE - redux, env...

//ASSETS - icons, images...
import { ReactComponent as Play } from "../../build/images/chatIcons/PlayIcon.svg";
import { ReactComponent as Pause } from "../../build/images/chatIcons/PauseIcon.svg";

function Audio({ content, link, audio, showImg }) {
  //GENERAL
  const ref = useRef();

  //STATES
  const [velocityAudio, setVelocityAudio] = useState(1);
  const [showTime, setShowTime] = useState(true);
  const [openVelocity, setOpenVelocity] = useState(false);

  //REDUX - Selectors

  //FUNCTIONS
  const increaseSpeed = () => {
    if (velocityAudio === 1) {
      setVelocityAudio(1.5);
      ref.current.audio.current.playbackRate = 1.5;
    } else if (velocityAudio === 1.5) {
      setVelocityAudio(2);
      ref.current.audio.current.playbackRate = 2;
    } else {
      setVelocityAudio(1);
      ref.current.audio.current.playbackRate = 1;
    }
  };

  function getDuration() {
    ref.current.audio.current.currentTime = 0;
    ref.current.audio.current.removeEventListener("timeupdate", getDuration);
  }

  function handlePlay() {
    setShowTime(false);
    setOpenVelocity(true);
  }

  function handleEnded() {
    setShowTime(true);
    setOpenVelocity(false);
  }

  //USE EFFECTS

  return (
    <AudioPlayer
      layout="horizontal-reverse"
      ref={ref}
      src={`${audio ? link : `${urlIngWeb}${link}`}`}
      onLoadedData={() => {
        if (ref.current && ref.current.audio.current.duration === Infinity) {
          ref.current.audio.current.currentTime = 1e101;
          ref.current.audio.current.addEventListener("timeupdate", getDuration);
        }
      }}
      autoPlayAfterSrcChange={false}
      showJumpControls={false}
      onPlay={() => handlePlay()}
      onEnded={() => handleEnded()}
      customControlsSection={[RHAP_UI.MAIN_CONTROLS]}
      customProgressBarSection={[
        RHAP_UI.PROGRESS_BAR,
        `${showTime && RHAP_UI.DURATION}`,

        openVelocity && (
          <button
            className="rhap_additional-controls"
            onClick={() => increaseSpeed()}
          >
            <Typography.H6 color="blue-selected-4" weight="500">
              {velocityAudio.toFixed(1)}x
            </Typography.H6>
          </button>
        ),
        !openVelocity && showImg && <UserPhoto size="medium" />,
        <div>{content}</div>,
      ]}
      customIcons={{
        play: <Play />,
        pause: <Pause />,
      }}
      // other props here
    />
  );
}

export default Audio;
